import SubHeaderBox from "../../NewCompany/CompanyDetail/components/SubHeaderBox";
import "./index.css";
import yfsLabelIcon from "../../../assets/new-product-detail-cats/yfs-label/yfs-prod-bg.svg";
import ProductExportLabel from "../../ProductYFSLabel/ProductExportLabel";

const YFSLabelProductDetail = (productData) => {
  return (
    <div className="yfs-prod-detail" id="yfs-label-id">
      <div style={{ display: "flex", gap: "13.24px", marginBottom: "38px" }}>
        <img src={yfsLabelIcon} alt="YFS Label Icon" width={74} height={75} />
        <SubHeaderBox
          subTitle={"YFS label"}
          subDescription={
            "Specify here how you expect your products and/or waste from your products to be disposed of when the end-users are done using them."
          }
          customStyle={{
            padding: "30px 30px 55px 30px",
          }}
        />
      </div>

      {/* <ProductSummary productData={productData.productData} editMode={false} /> */}
      <ProductExportLabel productData={productData.productData} />
    </div>
  );
};

export default YFSLabelProductDetail;
